import { Outlet } from "react-router";
import Navbar from "./Navabr";
import Footer from "./Footer";

// A basic layout component that provides a Navbar at the top of the page,
// * an Outlet in the middle, and a Footer at the bottom.
const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
